import React, { FC, ReactNode } from 'react';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import { useTripCartContext } from 'src/trip-cart-deprecated/hooks/useTripCartContext';
import classNames from 'classnames';
import getClassNames from 'src/common/utils/getClassNames';
import styles from './TripCartPanelTitle.module.scss';

export type TripCartDrawerTitleProps = {
  title: string;
  subtitle?: ReactNode;
  showClose?: boolean;
  border?: boolean;
};
const TripCartPanelTitle: FC<TripCartDrawerTitleProps> = ({
  title,
  subtitle = '',
  showClose,
  border,
}) => {
  const { closePanel } = useTripCartContext();
  return (
    <div className={getClassNames(styles, 'root', classNames({ border }))}>
      <div className={styles.title}>
        <Typography type="h2" size="body-xl" weight="semibold">{title}</Typography>
        {subtitle && (
          <Typography type="span" size="body-m" weight="regular">
            {subtitle}
          </Typography>
        )}
      </div>
      {showClose && (
        <div className={styles.close}>
          <Button
            icon="x"
            variant="primary-white"
            size="small"
            onClick={() => closePanel()}
          />
        </div>
      )}
    </div>
  );
};

export default TripCartPanelTitle;
